import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule, FormArray, FormsModule, FormControl, Validators } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { BASE_IMAGE_URL } from 'src/app/endpoints';
import { CommonModule, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { SafeUrlPipe } from 'src/app/shared/pipe/safe_url/safe_url_pipe.pipe';
import { MatTabsModule } from '@angular/material/tabs';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CategoryService } from 'src/app/shared/service/category/category.service';
import { CompanyService } from 'src/app/shared/service/company/company.service';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import { MedicalTestService } from 'src/app/shared/service/labTest/medical-test.service';
import JsBarcode from 'jsbarcode';
import { HasRoleDirective } from 'src/app/shared/directive/has-role.directive';
import { MatTooltipModule } from '@angular/material/tooltip';

declare var bootstrap: any;

@Component({
  selector: 'app-sample',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    MatIcon,
    ReactiveFormsModule,
    DatePipe,
    NgSelectModule,
    RouterLink,
    SafeUrlPipe,
    MatTabsModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatLabel,
    MatInputModule,
    CommonModule,
    HasRoleDirective,
    MatTooltipModule
  ],
  templateUrl: './sample.component.html',
  styleUrl: './sample.component.scss'
})
export class SampleComponent {

  // Component variables
  sampleDetailModal: any;
  AssignSampleModal: any;
  addTreatmentModal: any;
  categoryChangeModal: any;
  wardChangeModal: any;

  genders: any = '';
  genderData = [{ name: 'Male', id: 1 }, { name: 'Female', id: 2 }, { name: 'Others', id: 3 }];
  homeData = [{ name: 'Hospital', id: 2 }, { name: 'Home', id: 1 }];
  
  currentStatusData = [
    { name: 'All', id: '' },
    { name: 'Home', id: 'Home' },
    { name: 'Hospital', id: 'Hospital' },
    { name: 'Temporary Ward', id: 'Temporary Ward' },
    { name: 'Discharge', id: 'Discharge' },
    { name: 'Death', id: 'Death' },
    { name: 'Escaped', id: 'Escaped' },
    { name: 'Family Reunite', id: 'Family Reunite' },
    { name: 'LAMA', id: 'LAMA' },
    { name: 'Unknown', id: '-' }
  ];

  //// 1: Dealth /////  2: Family Reunite ///   3:Escape // 4:family Member

  closeType = [
    { name: 'No Closure', id: 0 },
    { name: 'Death', id: 1 },
    { name: 'Family Reunite', id: 2 },
    { name: 'Escape', id: 3 },
    { name: 'Family Member', id: 4 },
    { name: 'LAMA', id: 5 }
  ]



  dischargeModal: any;

  closeTypes = [
    { label: 'Death', value: 1 },
    { label: 'Family Reunite', value: 2 },
    { label: 'Escape', value: 3 },
    { label: 'NGO Family Member', value: 4 },
    { label: 'LAMA', value: 5 }

  ];

  startpoint: number = 0;
  search: any;
  totalLoaded: number = 0;
  total: any;
  pageNo: any;
  sampleId: any;
  name: any;
  pageSize: any;
  dataSource = new MatTableDataSource<any>([]);
  userData: any = [];
  dischargeFile: File | null = null;
  treatmentFile: File | null = null;
  // Displayed columns are dynamically set based on user role
  displayedColumns: string[] = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('barcodeElement') barcodeElement!: ElementRef;

  // Filter and category/company data
  sampleData: any;
  wholeSalerTotal: any;
  retailerTotal: any;
  allCategoriesMini: any;
  allCompanies: any;
  userType: any = '';

  // Reactive Form for assigning samples
  issueSampleForm = new FormGroup({
    rows: new FormArray([])
  });

  get rows() {
    return this.issueSampleForm.get('rows') as FormArray;
  }

  // Debounce handlers
  debounceNameTimer: any = null;
  debounceBarCodeTimer: any = null;

  // Sample search object
  sampleSearch: any = {
    name: '',
    barCode: '',
    category: undefined,
    company: undefined,
    startdate: null,
    enddate: null,
    gender: undefined,
    isHome: undefined,
    type: undefined,
    closeType: undefined,
    currentStatus: undefined,
    isShowDischage: undefined
  };

  isCompanyLoggedIn: boolean = false;
  categoryId: any = "";

  constructor(
    private sampleService: SampleService,
    private categoryService: CategoryService,
    private companyService: CompanyService,
    public userDataService: UserDataService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private wardService: CompanyService,
    private medicalTestService: MedicalTestService
  ) {
    this.setDisplayedColumns();
  }

  // Configure displayed columns based on user role
  setDisplayedColumns(): void {
    this.displayedColumns = [
      'srno',
      'name',
      'barcode',
      'totalItems',
      'requestWardStatus',
      // 'leftItems',
      'ageRange',
      'status',
      'createdAt',
      'preview'
    ];

    if (this.userDataService.roleMatch(['SAMPLE-ASSIGN'])) {
      this.displayedColumns.push('assignSample');
    }
    if (this.userDataService.roleMatch(['SAMPLE-EDIT'])) {
      this.displayedColumns.push('action');
    }
  }

  isTodaySample: any = false;
  ngOnInit(): void {
    const wardId = this.activatedRoute.snapshot.queryParamMap.get("wardId");
    if (wardId) {
      this.sampleSearch.company = wardId;
    }

    const isHomeParam = this.activatedRoute.snapshot.queryParamMap.get("isHome");
    if (isHomeParam) {
      this.sampleSearch.isHome = Number(isHomeParam);
      if (this.sampleSearch.isHome === 1) {
        this.sampleSearch.currentStatus = 'Home';
      }
    }
    
    const currentStatusParam = this.activatedRoute.snapshot.queryParamMap.get("currentStatus");
    if (currentStatusParam) {
      this.sampleSearch.currentStatus = currentStatusParam;
    }

    const typeParam = this.activatedRoute.snapshot.queryParamMap.get("type");
    if (typeParam) {
      this.sampleSearch.type = typeParam;
      if (typeParam === 'Home') {
        this.sampleSearch.currentStatus = 'Home';
      } else if (typeParam === 'Hospital') {
        this.sampleSearch.currentStatus = 'Hospital';
      } else if (typeParam === 'Temporary') {
        this.sampleSearch.currentStatus = 'Temporary Ward';
      }
    }

    this.isTodaySample = this.activatedRoute.snapshot.queryParamMap.get("isTodaySample");
    if (this.isTodaySample === 'true') {
      const today = new Date();
      this.sampleSearch.startdate = today;
      this.sampleSearch.enddate = today;
    }

    const isShowDischageParam = this.activatedRoute.snapshot.queryParamMap.get("isShowDischage");
    if (isShowDischageParam) {
      this.sampleSearch.isShowDischage = isShowDischageParam === 'true';
    }
    // this.getAllCategoriesMini();
    // this.allCompaniesMini();
    // this.getCompanyData();

    this.userData = this.userDataService.getData();

    if (this.userData) {
      this.userType = this.userData?.data?.userType;
      if (this.userType == 2) {
        this.sampleSearch.company = this.userData?.data?.assignedWard;
      }
    }

    this.getAllSamples(null);
    this.getAllCategories();
    this.fetchWards(undefined);

  }

  // Handle filter change
  sampleFilter(event: any): void {
    this.getAllSamples(null);
  }


  onTreatmentFileChange(event: any) {
    const file = event.target.files[0];

    if (file) {
      if (file.type !== 'application/pdf') {
        this.toastr.error('Only PDF file is allowed');
        return;
      }

      this.treatmentFile = file;
    }
  }

  onDischargeFileChange(event: any) {
    const file = event.target.files[0];

    if (file) {
      if (file.type !== 'application/pdf') {
        this.toastr.error('Only PDF file is allowed');
        return;
      }

      this.dischargeFile = file;
    }
  }

  // Fetch all minimal categories
  getAllCategoriesMini(): void {
    this.categoryService.allCategoriesMini({}).subscribe({
      next: (res) => {
        if (res.success) this.allCategoriesMini = res.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }

  // Handle debounce for name input
  onNameInputChange(event: any): void {
    clearTimeout(this.debounceNameTimer);
    this.debounceNameTimer = setTimeout(() => {
      const name = event.target.value.trim();
      this.sampleSearch.name = name || undefined;
      this.getAllSamples(null);
    }, 300);
  }

  // Handle debounce for barcode input
  onBarCodeInputChange(event: any): void {
    clearTimeout(this.debounceBarCodeTimer);
    this.debounceBarCodeTimer = setTimeout(() => {
      const code = event.target.value.trim();
      this.sampleSearch.barCode = code || undefined;
      this.getAllSamples(null);
    }, 300);
  }

  // Clear selected date range
  clearDateRange(): void {
    this.sampleSearch.startdate = null;
    this.sampleSearch.enddate = null;
    this.getAllSamples(null);
  }

  // Check if user has a company linked and fetch data accordingly
  getCompanyData() {
    let userData: any = this.userDataService.getData();
    let companyData: any = userData.company;
    if (!!companyData) {
      this.isCompanyLoggedIn = true;
      this.sampleSearch.company = companyData._id;
      this.getAllSamples(null);
    } else {
      this.isCompanyLoggedIn = false;
      this.getAllSamples(null);
    }
  }

  setDefaultImage(event: any) {
  event.target.src =
    'https://static.vecteezy.com/system/resources/previews/005/276/776/non_2x/logo-icon-person-on-white-background-free-vector.jpg';
}

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    const sampleDetailModalElement = document.getElementById('sampleDetailModal');
    if (sampleDetailModalElement) {
      this.sampleDetailModal = new bootstrap.Modal(sampleDetailModalElement);
    }

    ///
    const addTreatmentModal = document.getElementById('addTreatmentModal');
    if (addTreatmentModal) {
      this.addTreatmentModal = new bootstrap.Modal(addTreatmentModal);
    }

    //
    const categoryChangeModal = document.getElementById('categoryChangeModal');
    if (categoryChangeModal) {
      this.categoryChangeModal = new bootstrap.Modal(categoryChangeModal);
    }


    //
    const wardChangeModal = document.getElementById('wardChangeModal');
    if (wardChangeModal) {
      this.wardChangeModal = new bootstrap.Modal(wardChangeModal);
    }


    const closePersonModal = document.getElementById('closePersonModal');
    if (wardChangeModal) {
      this.dischargeModal = new bootstrap.Modal(closePersonModal);
    }

    // Initialize Medical Test Modal
    const ADDmedicalTestModalElement = document.getElementById('ADDmedicalTestModal');
    if (ADDmedicalTestModalElement) {
      this.ADDmedicalTestModal = new bootstrap.Modal(ADDmedicalTestModalElement);
    }

  }

  // Generate barcode using JsBarcode
  getSampleCode(sampleCode: any) {
    if (this.barcodeElement?.nativeElement && sampleCode) {
      JsBarcode(this.barcodeElement.nativeElement, sampleCode, {
        format: 'CODE128',
        lineColor: '#000000',
        background: '#ffffff',
        width: 1.5,
        height: 40,
        fontSize: 12,
        displayValue: true
      });
    } else {
      console.warn("Barcode element or sample code missing");
    }
  }

  // Generate full image path from base
  getImg(imgPath: any) {
    return BASE_IMAGE_URL + imgPath;
  }

  // Fetch all companies
  allCompaniesMini() {
    this.companyService.allCompaniesMini({}).subscribe({
      next: (result) => {
        if (result.success) this.allCompanies = result.data;
      },
      error: (e) => this.toastr.error(e)
    });
  }

  // Open modal to view sample details
  openModel(sampleId: any) {
    this.sampleId = sampleId;
    if (sampleId !== null) this.getSingleSample(sampleId);
    this.sampleDetailModal.show();
  }

  openModalAddTreatment(personId: any) {
    this.sampleId = personId;
    this.addTreatmentModal.show();
  }


  openModalAddCategoryChange(personId: any, categoryId: any) {
    this.categoryId = categoryId;
    this.addCategory.patchValue({ categoryId: categoryId });
    this.sampleId = personId;
    this.categoryChangeModal.show();
  }

  openModalAddWardChange(personId: any, wardId: any) {
    this.addWard.patchValue({ wardId: wardId });
    this.sampleId = personId;
    this.wardChangeModal.show();
  }


  openModalAddDischarge(personId: any) {
    this.sampleId = personId;
    this.dischargeModal.show();
  }

  // Hide sample details modal
  hideModel() {
    this.sampleDetailModal.hide();
  }

  hideAddTreatment() {
    this.addTreatmentModal.hide();
  }

  hideCategoryChange() {
    this.categoryChangeModal.hide();
  }

  hideWardChange() {
    this.wardChangeModal.hide();
  }



  // Fetch single sample data by ID
  getSingleSample(sampleId: any) {
    this.spinner.show();
    this.sampleService.singleSample({ _id: sampleId }).subscribe({
      next: (v: any) => {
        if (v.success) this.sampleData = v.data;
        else console.log(v.message);
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
      complete: () => this.spinner.hide()
    });
  }

  // Fetch all samples with current filters and pagination
  getAllSamples(event: any) {
    this.spinner.show();
    if (!event) {
      this.pageNo = 0;
      this.startpoint = 0;
      this.pageSize = this.pageSize || 10;
      this.dataSource.data = [];
    }
    if (event?.pageSize && event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.pageNo = 0;
      this.startpoint = 0;
      this.dataSource.data = [];
    }
    if (event?.pageIndex !== undefined) {
      this.pageNo = event.pageIndex;
      this.startpoint = this.pageNo * (this.pageSize || 10);
    }

    const data: any = {
      startpoint: this.startpoint,
      limit: this.pageSize,
      search: this.sampleSearch.name || undefined,
      categoryId: this.sampleSearch.category || undefined,
      startdate: this.sampleSearch.startdate || undefined,
      enddate: this.sampleSearch.enddate || undefined,
      wardId: this.sampleSearch.company || undefined,
      gender: this.sampleSearch.gender || undefined,
      isHome: this.sampleSearch.isHome || undefined,
      type: this.sampleSearch.type || undefined,
      closeType: this.sampleSearch.closeType !== undefined ? this.sampleSearch.closeType : undefined,
      currentStatus: this.sampleSearch.type ? undefined : ((this.sampleSearch.isHome === 1 && this.sampleSearch.currentStatus === 'Home') ? undefined : (this.sampleSearch.currentStatus || undefined)),
      isShowDischage: this.sampleSearch.isShowDischage || undefined
    };

    if (data.type) {
      this.fetchWards(data.type);
    } else if (data.isHome === 1) {
      this.fetchWards('Home');
    } else if (data.isHome === 2) {
      this.fetchWards('Hospital');
    } else {
      this.fetchWards(undefined);
    }

    this.sampleService.allSamples(data).subscribe({
      next: (result) => {
        if (result?.success) {
          this.total = result.total ?? 0;
          this.dataSource.data = result.data || [];
          setTimeout(() => {
            if (this.paginator) {
              this.paginator.pageIndex = this.pageNo;
              this.paginator.length = this.total;
              this.paginator.pageSize = this.pageSize;
            }
          }, 0);
        }
      },
      error: (error: any) => {
        let errorMsg = "An unexpected error occurred.";
        if (error.status === 0) {
          errorMsg = "Server not reachable. Please check your network connection.";
        } else if (error.error?.message) {
          errorMsg = error.error.message;
        } else if (error.message) {
          errorMsg = error.message;
        }
        this.toastr.error(errorMsg, "Error");
        console.error("Sample Fetch Error:", error);
      },
      complete: () => this.spinner.hide()
    });
  }

  // Toggle sample status (blocked/unblocked) with confirmation
  sampleStatus(element: any) {
    const currentStatus = element.isBlocked;
    const newStatus = !currentStatus;
    const action = newStatus ? 'Block' : 'Unblock';
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger',
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title: `${action} this Sample?`,
        text: `This will ${action.toLowerCase()} the Sample.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `${action}`,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.sampleService
            .enableDisableSample({ _id: element._id, isBlocked: newStatus })
            .subscribe({
              next: (v: any) => {
                if (v.success) {
                  element.isBlocked = newStatus;
                  this.toastr.success(`Sample ${action.toLowerCase()}ed successfully.`);
                } else {
                  this.toastr.error(v.message, 'Error');
                }
              },
              error: (e: any) => {
                this.toastr.error(e.message, 'Error');
              },
            });
        }
      });
    return false;
  }

  submitAddTreatment() {

    // if (this.addTreatment.invalid) {
    //   this.toastr.error('Remarks are required');
    //   return;
    // }

    const formData = new FormData();

    formData.append('remarks', this.addTreatment.value.remarks ?? '');

    if (this.sampleId) {
      formData.append('personId', this.sampleId);
    }

    //  Append PDF file
    if (this.treatmentFile) {
      formData.append('treatment_image', this.treatmentFile);
    }

    this.spinner.show();

    this.sampleService.addTreatment(formData).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        if (res.success) {
          this.hideAddTreatment();
          this.toastr.success(res.message, 'Success');

          // Reset
          this.addTreatment.reset();
          this.treatmentFile = null;

        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      }
    });
  }




  addTreatment = new FormGroup({
    remarks: new FormControl(""),
  });

  medicalTestForm = new FormGroup({
    testName: new FormControl('', Validators.required),
    selectedTests: new FormControl([], Validators.required),
    otherTests: new FormArray([]), // Changed to FormArray for multiple tests with name and price
    remarks: new FormControl(''),
    testImages: new FormControl<File[]>([])
  });

  // Predefined tests from API
  predefinedTests: any[] = [];
  selectedFiles: File[] = [];
  imagePreviews: string[] = [];
  ADDmedicalTestModal: any;

  // Methods for managing other tests FormArray
  get otherTestsFormArray(): FormArray {
    return this.medicalTestForm.get('otherTests') as FormArray;
  }

  addOtherTest() {
    const testGroup = new FormGroup({
      name: new FormControl('', Validators.required),
      price: new FormControl('', [Validators.required, Validators.pattern('^[0-9]+(\\.[0-9]{1,2})?$')])
    });
    this.otherTestsFormArray.push(testGroup);
  }

  removeOtherTest(index: number) {
    this.otherTestsFormArray.removeAt(index);
  }

  // Fetch all lab tests from API
  getAllLabTests() {
    this.medicalTestService.getAllTests({}).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.predefinedTests = res.data || [];
        }
      },
      error: (e) => {
        this.toastr.error('Failed to load lab tests');
      }
    });
  }

  onFileChange(event: any) {
    if (event.target.files) {
      // Accumulate files instead of replacing them
      const newFiles = Array.from(event.target.files) as File[];
      this.selectedFiles = [...this.selectedFiles, ...newFiles];

      // Generate image previews for new files
      newFiles.forEach((file: File) => {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.imagePreviews.push(e.target.result);
        };
        reader.readAsDataURL(file);
      });

      // Clear the file input value to allow selecting the same files again
      event.target.value = '';
    }
  }

  removeImagePreview(index: number) {
    this.selectedFiles.splice(index, 1);
    this.imagePreviews.splice(index, 1);
  }

  openADDmedicalTestModal(personId: any) {
    this.sampleId = personId;
    this.getAllLabTests();

    // Reset form
    this.medicalTestForm.reset();
    this.otherTestsFormArray.clear(); // Clear the FormArray
    this.selectedFiles = [];
    this.imagePreviews = [];

    // Reset file input
    const fileInput = document.querySelector('#medicalTestFileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }

    if (this.ADDmedicalTestModal) {
      this.ADDmedicalTestModal.show();
    }
  }

  hideADDmedicalTestModal() {
    if (this.ADDmedicalTestModal) {
      this.ADDmedicalTestModal.hide();
    }
  }

  submitMedicalTest() {
    if (!this.medicalTestForm.valid) {
      this.toastr.error('Please fill all required fields');
      return;
    }

    const formData = new FormData();

    // Basic fields
    formData.append('name', this.medicalTestForm.value.testName || '');
    formData.append('PersonId', this.sampleId);
    formData.append('DoctorId', this.userData?.data?._id || '');
    formData.append('Remark', this.medicalTestForm.value.remarks || '');

    // Tests array - send as individual fields
    const selectedTests = this.medicalTestForm.value.selectedTests as any[];
    if (selectedTests && selectedTests.length > 0) {
      selectedTests.forEach((testId: string, index: number) => {
        formData.append(`Tests[${index}]`, testId);
      });
    }

    // OtherTest array of objects - send as individual fields
    const otherTests = this.medicalTestForm.value.otherTests as any[];
    if (otherTests && otherTests.length > 0) {
      otherTests.forEach((test: any, index: number) => {
        formData.append(`OtherTest[${index}][name]`, test.name || '');
        formData.append(`OtherTest[${index}][price]`, test.price || '');
      });
    }

    // Test_Files (single field name, multiple files)
    this.selectedFiles.forEach((file: File) => {
      formData.append('Test_Files', file);
    });

    this.spinner.show();

    this.medicalTestService.addMedicalTest(formData).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.success) {
          this.toastr.success(res.message || 'Medical test added successfully');
          this.hideADDmedicalTestModal();
          this.medicalTestForm.reset();
          this.otherTestsFormArray.clear(); // Clear the FormArray
          this.selectedFiles = [];
          this.imagePreviews = [];
        } else {
          this.toastr.error(res.message || 'Failed to add medical test');
        }
      },
      error: (err: any) => {
        this.spinner.hide();
        this.toastr.error(err.error?.message || 'An error occurred');
      }
    });
  }

  addCategory = new FormGroup({
    remarks: new FormControl(""),
    _id: new FormControl(""),
    categoryId: new FormControl('', [Validators.required])
  })


  addWard = new FormGroup({
    remarks: new FormControl(""),
    _id: new FormControl(""),
    wardId: new FormControl(''),
    volunteerName: new FormControl('', [Validators.required])
  })



  submitCategoryChange() {

    let data: any = this.addCategory.value;

    if (this.sampleId) {
      data._id = this.sampleId;
    }
    this.spinner.show();

    this.sampleService.addCategoryLogs(data).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.success) {

          this.hideCategoryChange();
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }



  submitWardChange() {

    let data: any = this.addWard.value;

    if (this.sampleId) {
      data._id = this.sampleId;
    }
    this.spinner.show();

    if (this.userData?.userType == 9) {
      data.isReceptionRole = true;
    }

    this.sampleService.addWardLogs(data).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.success) {

          this.hideWardChange();
          this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }


  addDischarge = new FormGroup({
    remarks: new FormControl(""),
  })


  // Category dropdown data
  categories: any[] = [];

  wardData: any = [];

  // Fetch all unblocked categories
  getAllCategories() {
    this.categoryService.allCategories({ isBlocked: false }).subscribe({
      next: (result) => {
        if (result.success) {
          this.categories = result.data;
        }
      },
      error: (e) => {
        this.toastr.error(e);
      }
    });
  }

  fetchWards(type: any) {
    this.wardService.allCompanies({ type: type }).subscribe({
      next: (result) => {
        this.spinner.hide();
        if (result.success) {
          this.wardData = result.data;
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
    });
  }



  closeForm: any = new FormGroup({
    closeType: new FormControl(null, Validators.required),
    remarks: new FormControl(''),

    wardId: new FormControl(null),

    fname: new FormControl(''),
    fphone: new FormControl(''),
    fanotherPhone: new FormControl(''),
    froofType: new FormControl(''),
    famproofNo: new FormControl(''),
    faddress: new FormControl(''),
  });


  handleCloseTypeChanges() {
    this.closeForm.get('closeType')?.valueChanges.subscribe((value: any) => {

      // Reset all dynamic validators
      this.closeForm.get('wardId')?.clearValidators();
      this.clearFamilyValidators();

      if (value == 4) {
        this.closeForm.get('wardId')?.setValidators(Validators.required);
      }

      if (value == 2) {
        this.setFamilyValidators();
      }

      this.closeForm.get('wardId')?.updateValueAndValidity();
      this.updateFamilyValidity();
    });
  }



  setFamilyValidators() {
    // this.closeForm.get('fname')?.setValidators(Validators.required);
    // this.closeForm.get('fphone')?.setValidators(Validators.required);
    // this.closeForm.get('fproofType')?.setValidators(Validators.required);
    // this.closeForm.get('fproofNo')?.setValidators(Validators.required);
    // this.closeForm.get('faddress')?.setValidators(Validators.required);
  }

  clearFamilyValidators() {
    const fields = [
      'fname',
      'fphone',
      'fanotherPhone',
      'fproofType',
      'fproofNo',
      'faddress'
    ];

    fields.forEach(field => {
      this.closeForm.get(field)?.clearValidators();
    });
  }

  updateFamilyValidity() {
    const fields = [
      'fname',
      'fphone',
      'fanotherPhone',
      'fproofType',
      'fproofNo',
      'faddress'
    ];

    fields.forEach(field => {
      this.closeForm.get(field)?.updateValueAndValidity();
    });
  }

  submitCloseForm() {

    if (this.closeForm.invalid) {
      this.toastr.error('Please fill required fields');
      return;
    }

    const formData = new FormData();

    const data: any = this.closeForm.value;

    // Append all fields
    Object.keys(data).forEach(key => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });

    // Append personId
    if (this.sampleId) {
      formData.append('personId', this.sampleId);
    }

    //  Append PDF file with backend key
    if (this.dischargeFile) {
      formData.append('discharge_image', this.dischargeFile);
    }

    this.spinner.show();

    this.sampleService.addDischage(formData).subscribe({
      next: (res: any) => {
        this.spinner.hide();

        if (res.success) {
          this.hideCloseModal();
          this.toastr.success(res.message, 'Success');

          // Reset
          this.closeForm.reset();
          this.dischargeFile = null;
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      }
    });
  }

  hideCloseModal() {
    this.dischargeModal.hide();
  }


  isCategoryDisabled = (item: any) => {
    return item._id === this.categoryId;
  };



}
